<template>
  <p>
    <template
      v-for="(item, i) in dimensionsBullets"
      :key="i"
      data-auto="product-dimensions-text"
    >
      {{ `${item} ` }}
    </template>
  </p>
</template>

<script setup>
import { useProductDetails } from '../composables';

const { dimensionsBullets } = useProductDetails();
</script>
